/**
 * MBTI — **선택 입력**. 해석의 말투·조언 방식을 개인화하는 용도로만 쓴다.
 * 회원은 내 정보에 저장(users.mbti)해 두면 자동 적용, 비회원·방 참여자는 그때그때 선택.
 * 미입력이 기본값이며, 없어도 모든 기능이 동일하게 동작한다.
 */
export const MBTI_TYPES = [
  'ISTJ',
  'ISFJ',
  'INFJ',
  'INTJ',
  'ISTP',
  'ISFP',
  'INFP',
  'INTP',
  'ESTP',
  'ESFP',
  'ENFP',
  'ENTP',
  'ESTJ',
  'ESFJ',
  'ENFJ',
  'ENTJ',
] as const;

export type Mbti = (typeof MBTI_TYPES)[number];

export const isMbti = (v: unknown): v is Mbti => MBTI_TYPES.includes(v as Mbti);

/**
 * 프롬프트에 넣을 성향 힌트 — 축별 한 줄 요약.
 * 모델이 MBTI 설명을 늘어놓지 않고 "말투·조언 방식"만 조정하도록 유도한다.
 */
export function describeMbti(mbti: Mbti): string {
  const hints = [
    mbti[0] === 'E' ? '사람들과 나누며 에너지를 얻는 편(E)' : '혼자 정리하며 에너지를 얻는 편(I)',
    mbti[1] === 'S'
      ? '구체적이고 현실적인 이야기를 선호(S)'
      : '의미와 가능성을 짚어주는 이야기를 선호(N)',
    mbti[2] === 'T'
      ? '感보다 근거·해결책을 원함(T) → 공감은 짧게, 실행 가능한 조언 위주로'
      : '먼저 마음을 알아주길 원함(F) → 공감과 위로를 충분히 먼저',
    mbti[3] === 'J' ? '계획과 정리된 결론을 선호(J)' : '여지를 남기는 유연한 제안을 선호(P)',
  ];
  return `${mbti} — ${hints.join(', ')}`;
}
